import { Navigate, Outlet } from "react-router-dom";
import { DASHBOARD } from "../utils/ConstantLinks";

function UserLayout() {
  // Redirect to DASHBOARD if user is logged in, otherwise render nested routes
  return localStorage.accessToken ? (
    <Navigate to={DASHBOARD} /> // Redirect to DASHBOARD route if user is logged in
  ) : (
    <div>
      <Outlet /> {/* Render nested routes */}
    </div>
  );
}

export default UserLayout;
